
export default {
    
    ALL_ROUTES:'*',

    ADMINLOGIN: '/adminLogin',
    
    ENACH_SIGNDESK: '/smandate/:loanId',
    ENACH_SIGNDESK_MOBILE: '/mandatemobile/:loanId',
    FEEDBACK: '/feedback/:userId',
    UPLOAD_DOCUMENT: '/uploadDocuments/:userId',

    E_NACH_PAGE: '/enach/:loanId',
    E_NACH_EV_PAGE: '/enachEv/:loanId',
    E_SIGN_NACH_PAGE: '/esignEnach/:loanId',

    ENACH_BY_CASHFREE: '/enach/cashfree/:loanId',
    ENACH_BY_CASHFREE_EV: '/enach/cashfreeEv/:loanId',
    E_SIGN_PAGE: '/esign/:loanId',
    E_SIGN_PAGE_EV: '/esignEv/:loanId',
    E_SIGN_SIGNZY_PAGE_EV: '/esignSignzy/:loanId',

    Reference: '/userReference/:userId',

    E_NACH_PAGE_MOBILE: '/enachMobile/:loanId',
    E_SIGN_PAGE_MOBILE: '/esignMobile/:loanId',
    E_NACH_PAGE_CARD: '/enachCard/:userId',
    E_SIGN_PAGE_CARD: '/esignCard/:userId',
    SEIGNDESK_REDIRECT_URL: '/signdeskmandate',

    KYC_FORM: '/kyc/:userId',
    KYC_MOBILE: '/kycMobile/:userId',
    KYC_SIGNZY: '/kycSignzy/:userId',
    DIGILOCKER_KYC: '/digikyc/:userId',
    KYC_DIGITAP: '/kycDigitap/:userId',
    KYC_REDIRECT_URL_DIGITAP: '/da',

    KFS_PAGE: '/kfs/:loanId',
    KYC_FORM_DIGILOCKER: '/kycDigilocker/*',
    KFS_PAGE_NEW: '/kfsnew/:loanId',

    LEGAL_NOTICE: '/legalnotice/:loanId',
    ESIGN_REDIRECT_URL: '/redirectUser',
    ESIGN_REDIRECT_URL_SIGNZY: '/redirectUserSignzy',
    KYC_REDIRECT_URL: '/redirectKYCUser',
    KYC_REDIRECT_URL_MSITE: '/redirectKYCUserMsite',
    UPLOAD_DOCUMENT_REDIRECT: '/uploadDocumentsRedirect/:userId/:success',

    CRIF_URL: '/crif',
    ESIGN_REDIRECT_URL_EV: '/redirectUserEVCallback',
    SOA: '/soa/:loanId',
    SOA_EV: '/soaEv/:loanId',
    E_NACH_PAGE_UPI: '/enach/upi/:loanId',

    EV_TVR_URL: '/EVTVR/:loanId',
    EV_LOANCHECK_URL: '/loanCheck/:loanId/:userId',
    VIEW_TRANSACTION_RECIEPT: '/transactionReciept/:paymentId',

    LOAN_AGGREGEMENT_LINK: '/loanAggrement/:loanId',
    ACCOUNT_AGGREGAOTR_LINK: '/AccountAggregator/:successParam',
    ACCOUNT_AGGREGAOTR_MSITE_LINK: '/AccountAggregatorMsite/:successParam',

    ACCOUNT_AGGREGAOTR_GENERATE_LINK: '/AccountAggregatorLink/:userId',

    SELFIE_LINK: '/selfieUpload/:userId',

};